var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-carousel",style:({ height: _vm.height, width : _vm.width })},[_c('div',{directives:[{name:"mousewheel",rawName:"v-mousewheel.stop",value:(_vm.changeScale),expression:"changeScale",modifiers:{"stop":true}}],staticClass:"h-carousel__container"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-420e93ea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./package/carousel/src/main.vue
// module id = null
// module chunks = 